module.exports = __webpack_public_path__ + "images/fa-bf2024-bg-hero-laptop.webp";